import MapHandler from "../../map/MapHandler";
import TimeWheel from "../gui/TimeWheel";

export default class TimeNavigator {
  #gui;
  #oldX;
  #oldY;
  #oldAngle;

  #movementThreshold = 0.01;
  #angleThreshold = 0.1;

  constructor(gui: TimeWheel) {
    this.#gui = gui; //new TimeWheel.js();
    this.#oldX = -1;
    this.#oldY = -1;
    this.#oldAngle = -1;
  }

  onAddObject(evt: any, maphandler: MapHandler) {
    this.#gui.addWheel(evt.xPos, evt.yPos, evt.angle);
    this.#oldX = evt.xPos;
    this.#oldY = evt.yPos;
    this.#oldAngle = evt.angle;
  }

  onUpdateObject(evt: any) {
    if (this.#isSignificantChange(evt.xPos, evt.yPos, evt.angle)) {
      this.#gui.updateWheel(evt.xPos, evt.yPos, evt.angle);
      this.#oldX = evt.xPos;
      this.#oldY = evt.yPos;
      this.#oldAngle = evt.angle;
    }
  }

  onRemoveObject(evt: any) {
    this.#gui.removeWheel();
  }

  #isSignificantChange(newX: number, newY: number, newAngle: number) {
    const deltaX = Math.abs(newX - this.#oldX);
    const deltaY = Math.abs(newY - this.#oldY);
    const deltaAngle = Math.abs(newAngle - this.#oldAngle);

    return (
      deltaX > this.#movementThreshold ||
      deltaY > this.#movementThreshold ||
      deltaAngle > this.#angleThreshold
    );
  }
}
